export default [
    {
        name:'journal',
        path:'journal',
        meta: { title: '操作日志' },
        component: ()=>import('@/pages/journal/index.vue')
    }
]